import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconTopbarHiddenTopWide: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconTopbarHiddenTopWide"><Path fillRule="evenodd" clipRule="evenodd" d="M21.25 4C21.6642 4 22 4.33579 22 4.75V19.25C22 19.6642 21.6642 20 21.25 20H2.75C2.33579 20 2 19.6642 2 19.25V4.75C2 4.33579 2.33579 4 2.75 4H21.25ZM7 8C6.58579 8 6.25 8.33579 6.25 8.75C6.25 9.16421 6.58579 9.5 7 9.5H17C17.4142 9.5 17.75 9.16421 17.75 8.75C17.75 8.33579 17.4142 8 17 8H7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconTopbarHiddenTopWide;
